// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ratioBlock__pyJsi {
  width: 100px;
  display: flex;
  column-gap: 1px;
}
@media (max-width: 1200px) {
  .ratioBlock__pyJsi {
    width: 100%;
    max-width: 75px;
  }
}

.noItems__VNElI {
  width: 100%;
  background-color: var(--labels-filled-surface-empty);
}

.ratioBlockPart__r3UfS {
  height: 12px;
  border-radius: 1px;
}

.standard__ojrO5 {
  background-color: var(--labels-filled-surface-standard);
}

.high__K5JMC {
  background-color: var(--labels-filled-surface-high);
}

.critical__T1tn_ {
  background-color: var(--labels-filled-surface-critical);
}

.noAi___g_6B {
  background-color: var(--errors-and-states-green);
}`, "",{"version":3,"sources":["webpack://./../src/pages/HardwareOverview/components/Ratio/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAzEF;AA2EE;EALF;IAMI,WAAA;IACA,eAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;EACA,oDAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,uDAAA;AAxEF;;AA0EA;EACE,mDAAA;AAvEF;;AAyEA;EACE,uDAAA;AAtEF;;AAwEA;EACE,gDAAA;AArEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.ratioBlock {\n  width: 100px;\n  display: flex;\n  column-gap: 1px;\n\n  @media (max-width: 1200px) {\n    width: 100%;\n    max-width: 75px;\n  }\n}\n\n.noItems {\n  width: 100%;\n  background-color: var(--labels-filled-surface-empty);\n}\n\n.ratioBlockPart {\n  height: 12px;\n  border-radius: 1px;\n}\n\n.standard {\n  background-color: var(--labels-filled-surface-standard);\n}\n.high {\n  background-color: var(--labels-filled-surface-high);\n}\n.critical {\n  background-color: var(--labels-filled-surface-critical);\n}\n.noAi {\n  background-color: var(--errors-and-states-green);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ratioBlock": `ratioBlock__pyJsi`,
	"noItems": `noItems__VNElI`,
	"ratioBlockPart": `ratioBlockPart__r3UfS`,
	"standard": `standard__ojrO5`,
	"high": `high__K5JMC`,
	"critical": `critical__T1tn_`,
	"noAi": `noAi___g_6B`
};
module.exports = ___CSS_LOADER_EXPORT___;
